import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

/**
 * Module Subscription Service
 * Handles all API calls related to module subscriptions for branches
 */

const moduleSubscriptionService = {
  /**
   * Get modules subscribed by a specific branch
   * @param {string} branchId - The ID of the branch
   * @returns {Promise} Array of modules subscribed by the branch
   */
  getBranchModules: async (branchId) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.MODULE_SUBSCRIPTION.GET_BRANCH_MODULES(branchId)
      );
      
      console.log('🔍 Service - Full response:', response);
      console.log('🔍 Service - response.data:', response.data);
      
      // The data might be directly in response or in response.data
      return response.data || response;
    } catch (error) {
      console.error(`Error fetching modules for branch ${branchId}:`, error);
      throw error;
    }
  },

  /**
   * Update module subscriptions for a branch
   * @param {string} branchId - The ID of the branch
   * @param {Array<string>} modules - Array of module codes to subscribe
   * @returns {Promise} Updated subscription response
   */
  updateBranchModules: async (branchId, modules) => {
    try {
      console.log('📤 Service - Sending POST:', {
        url: ENDPOINTS.MODULE_SUBSCRIPTION.UPDATE_BRANCH_MODULES(branchId),
        payload: { modules }
      });
      
      const response = await apiClient.post(
        ENDPOINTS.MODULE_SUBSCRIPTION.UPDATE_BRANCH_MODULES(branchId),
        { modules }
      );
      
      console.log('✅ Service - POST response:', response);
      
      return response.data || response;
    } catch (error) {
      console.error(`Error updating modules for branch ${branchId}:`, error);
      throw error;
    }
  },

  /**
   * Delete/unsubscribe a specific module from a branch
   * @param {string} branchId - The ID of the branch
   * @param {string} moduleCode - The code of the module to unsubscribe
   * @returns {Promise} Deletion response
   */
  deleteBranchModule: async (branchId, moduleCode) => {
    try {
      const response = await apiClient.delete(
        ENDPOINTS.MODULE_SUBSCRIPTION.DELETE_BRANCH_MODULE(branchId, moduleCode)
      );
      return response.data || response;
    } catch (error) {
      console.error(`Error deleting module ${moduleCode} for branch ${branchId}:`, error);
      throw error;
    }
  },

  /**
   * Get modules accessible by the current user
   * @returns {Promise} Object with user's accessible modules
   */
  getCurrentUserModules: async () => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.MODULE_SUBSCRIPTION.GET_CURRENT_USER_MODULES
      );
      return response.data || response;
    } catch (error) {
      console.error('Error fetching current user modules:', error);
      throw error;
    }
  },
};

export default moduleSubscriptionService;